import { useState, useEffect } from "react"
import moment from "moment"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

const SapGoLivePopup = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [hasChecked, setHasChecked] = useState(false)
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 })
  const [isLive, setIsLive] = useState(false)

  useEffect(() => {
    const closedCountStr = localStorage.getItem("sap_go_live_popup_closed") || "0"
    const closedCount = parseInt(closedCountStr, 10)

    const targetDateStr = "2026-04-01T08:00:00+07:00"
    const targetTime = moment(targetDateStr)

    const calculateTimeLeft = () => {
      const now = moment()
      const difference = targetTime.diff(now)

      if (difference <= 0) {
        setIsLive(true)
        return { hours: 0, minutes: 0, seconds: 0 }
      }

      const duration = moment.duration(difference)
      return {
        hours: Math.floor(duration.asHours()),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      }
    }

    setTimeLeft(calculateTimeLeft())

    const timer = setInterval(() => {
      const remainingResult = calculateTimeLeft()
      setTimeLeft(remainingResult)

      if (remainingResult.hours === 0 && remainingResult.minutes === 0 && remainingResult.seconds === 0) {
        clearInterval(timer)
      }
    }, 1000)

    if (closedCount < 3) {
      setIsOpen(true)
    }
    setHasChecked(true)

    return () => clearInterval(timer)
  }, [])

  const handleClose = () => {
    setIsOpen(false)
    const closedCountStr = localStorage.getItem("sap_go_live_popup_closed") || "0"
    const newCount = parseInt(closedCountStr, 10) + 1
    localStorage.setItem("sap_go_live_popup_closed", newCount.toString())
  }

  const handleGoToSap = () => {
    window.open("https://my436551.s4hana.cloud.sap/ui#Shell-home", "_blank")
    handleClose()
  }

  if (!hasChecked) return null

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) handleClose()
      }}
    >
      <DialogContent showCloseButton={true} className="sm:max-w-md w-[95vw] rounded-[24px]">
        <DialogHeader className="flex flex-col items-center pb-0">
          <img
            src="/assets/icons/ic_sap-icon.svg"
            alt="SAP Production Logo"
            className="w-20 h-20 object-contain"
            onError={e => {
              e.currentTarget.style.display = "none"
            }}
          />
          <DialogTitle className="text-2xl text-primary-500 text-center font-semibold">{isLive ? "SAP is Now Live!" : "SAP Production Go-Live"}</DialogTitle>
          <DialogDescription className="text-center mt-2 text-base text-slate-500">
            {isLive ? "The SAP Production system you have been waiting for is officially running and ready to use." : "System is completing final preparations. Get ready for your new workspace!"}
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}

const TimeBox = ({ value, label }) => (
  <div className="flex flex-col items-center w-16">
    <div className="bg-gradient-to-br from-primary-600 to-primary-500 text-white text-2xl font-bold w-full h-[60px] flex justify-center items-center rounded-xl shadow-md">{String(value).padStart(2, "0")}</div>
    <span className="mt-2 text-slate-500 text-[10px] uppercase tracking-wide font-bold">{label}</span>
  </div>
)

export default SapGoLivePopup
